<template>
    <div class="product" :class="{ 'no-padding': product.noPadding }">
        <div
            v-if="product.badge === 'blank'"
            class="add-badge blank"
        >
            <p v-html="product.badgeText"></p>
        </div>
        <div
            v-else-if="product.showBadge && product.badge"
            class="add-badge"
            :class="product.badge !== 'placeholder' ? product.badge : null"
        ></div>

        <div
            class="product-header"
            :class="{ 'left-align': product.headerLeftAlign }"
        >
            <p>{{ product.title }}</p>
            <p>{{ product.subtitle }}</p>
        </div>

        <div class="product-body">
            <template v-if="product.originalPrice">
                <div class="break-line"></div>
                <p class="price original">{{ product.originalPrice }}</p>
            </template>

            <p class="price discount">
                <span v-if="product.discountPriceInValueSpan" class="value">
                    {{ product.discountPrice }}
                </span>
                <template v-else>{{ product.discountPrice }}</template>
            </p>

            <p
                v-if="product.bonusDesc || product.bonusDescHidden"
                class="price-desc new"
                :class="{ hide: product.bonusDescHidden }"
            >
                {{ product.bonusDesc }}
            </p>

            <p v-if="product.priceDesc" class="price-desc">
                {{ product.priceDesc }}
            </p>

            <p
                v-if="product.showSubDesc || product.subDesc"
                class="price-desc sub"
                :class="{ color: product.subDescColored }"
            >
                {{ product.subDesc }}
            </p>

            <button @click="$emit('purchase', product.link)">立即购买</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MembershipProductCard',
    props: {
        product: {
            type: Object,
            required: true
        }
    }
}
</script>
